import React from "react";
import MuxPlayer from "@mux/mux-player-react";
import { Box } from "@mui/material";

export const WBDemoVideo: React.FC = () => {
  return (
    <Box
      width={1}
      height={1}
      sx={{
        aspectRatio: 16 / 9,
        "& mux-player::part(control-bar)": {
          display: "none",
        },
        "& mux-player::part(center-controls)": {
          display: "none",
        },
        "& mux-player::part(bottom time range)": {
          display: "none",
        },
        "& mux-player::part(time-display)": {
          display: "none",
        },
      }}
    >
      <MuxPlayer
        playbackId="Rd9xulxeCzEwTo00pIf4cPrnk019wl7KuffGCU24xORYg"
        metadata={{
          video_title: "Write Better",
        }}
        style={{
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  );
};
